var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountabilityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 114,
    viewBox: "0 0 95 114",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2480_5740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7424 83.7942V65.1973H48.2617V83.7942",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0822 83.7948V67.6152H61.6016V83.7948",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.563 83.7947V62.4453H68.0586V83.7947",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6024 83.7948V71.7559H54.7656V83.7948",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 67.9492H40.7816",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 73.0957H40.7816",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 78.2891H31.9033",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9531 25.6094H74.5879",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9531 31.8086H74.5879",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9531 37.6484H64.0005",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1526 25.6094C22.8589 25.6094 18.5859 29.9415 18.5859 35.2309C18.5859 40.5204 22.8589 44.8765 28.1526 44.8765C33.4464 44.8765 37.7193 40.5444 37.7193 35.2309",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4883 23.5508V34.9196H39.7642C39.7642 28.6488 34.7316 23.5508 28.4883 23.5508Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2473 85.1582H46.9062",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2133 12.5176V101.744C88.2133 104.952 85.6257 107.513 82.4922 107.513H20.6055",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04635 102.726H81.0428C82.3485 102.726 83.4642 101.649 83.4642 100.284V3.94911C83.4642 2.58485 82.3485 1.50781 81.0428 1.50781H8.04635C6.69324 1.50781 5.625 2.58485 5.625 3.94911V14.8153",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9831 17.3281V104.951C92.9831 109.02 89.6834 112.323 85.6479 112.323H25.043",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3744 82.0697V30.3477C10.3269 28.6724 8.95004 27.332 7.24086 27.332H4.58212C2.87294 27.332 1.49609 28.6963 1.49609 30.3956V82.0697H10.3744Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3744 33.5312H1.49609",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74562 92.362L10.3509 82.0703H1.47266L5.65067 92.362C5.65067 92.362 5.72188 92.386 5.72188 92.362H5.74562Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2480_5740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.48,
    height: 113.831,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountabilityIcon);
export default __webpack_public_path__ + "static/media/accountability-icon.a544a5d5.svg";
export { ForwardRef as ReactComponent };